// Basit yatay bar dağılımı (imparatorluk / seviye / item penceresi kırılımları).
// segments: [{ label, value, color }]
const PALETTE = ['var(--accent)', 'var(--info)', 'var(--ok)', 'var(--warn)', 'var(--crit)', 'var(--text-3)'];

export default function MiniBars({ segments = [], stacked = false }) {
  const clean = segments.filter((s) => Number(s.value) > 0);
  const total = clean.reduce((s, x) => s + Number(x.value), 0) || 1;

  if (stacked) {
    return (
      <div>
        <div className="mb-track">
          {clean.map((s, i) => (
            <div key={s.label} className="mb-fill" style={{ width: `${(s.value / total) * 100}%`, background: s.color || PALETTE[i % PALETTE.length] }} title={`${s.label}: ${s.value}`} />
          ))}
        </div>
        <div className="mb-legend">
          {clean.map((s, i) => (
            <span key={s.label}>
              <i style={{ background: s.color || PALETTE[i % PALETTE.length] }} />
              {s.label} · {Math.round((s.value / total) * 100)}%
            </span>
          ))}
        </div>
      </div>
    );
  }

  const max = Math.max(...clean.map((s) => Number(s.value)), 1);
  return (
    <div className="mb-rows">
      {clean.map((s, i) => (
        <div key={s.label} className="mb-row">
          <span className="mb-row-label">{s.label}</span>
          <div className="mb-row-track">
            <div className="mb-fill" style={{ width: `${(s.value / max) * 100}%`, background: s.color || PALETTE[i % PALETTE.length] }} />
          </div>
          <span className="mb-row-val">{Number(s.value).toLocaleString('tr-TR')}</span>
        </div>
      ))}
    </div>
  );
}
